import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import TrucksTable from './TrucksTable';
import { CATEGORY_BY_SLUG } from '../utils/vehicleCategories';

export default function TrucksCategoryPage() {
  const { categorySlug } = useParams();
  const cat = CATEGORY_BY_SLUG[categorySlug];

  if (!cat) return <Navigate to="/trucks" replace />;

  return (
    <TrucksTable
      categoryId={cat.id}
      pageTitle={cat.label}
      pageSubtitle="Fleet specifications and status overview"
    />
  );
}

